    import api from '../api/config';

    export const getPackages = async () => {
    try {
        const response = await api.get('/get-packages');
        return response.data;
    }
        catch (error) {
        console.error('Erreur getPackages:', error);
        throw error;
    }
    };

    export const getSouscriptionType = async () => {
        try {
        const response = await api.get('/get-types');
        return response.data;
    } catch (error) {
        console.error('Erreur getSouscriptionType:', error);
        throw error;
    }
    };

    // avoir les infos les infosmedicales du souscripteur

    export const getMedicalInfo = async () => {
        try {
        const response = await api.get('/get-medicale-infos');
        console.log('Response from /get-medicale-infos:', response.data);
        return response.data;
        } catch (error) {
        console.error('Erreur getMedicalInfo:', error);
        throw error;
        }
        
    };

    export const postCotation = async (data) => {
        try {
            console.log('Data sent to /get-cotation:', data);
            const response = await api.post('/get-cotation', data);
            console.log('Response from /get-cotation:', response.data);
            return response.data;
        }
        catch (error) {
            console.error('Erreur postCotation:', error);
            throw error;
        }
    };
